// src/lib/utils/statusConverter.ts
export type OpportunityStatusString = "0" | "1" | "2" | "3" | "4" | "5";

export const convertStatusStringToSwedish = (
  statusString: OpportunityStatusString
): string => {
  const statusMap: Record<OpportunityStatusString, string> = {
    "0": "Ej satt",
    "1": "Pre-sale",
    "2": "Pågående",
    "3": "Offert skickad",
    "4": "Vunnen",
    "5": "Förlorad",
  };

  return statusMap[statusString] || "Okänd";
};

export const getStatusColorByString = (
  statusString: OpportunityStatusString
): string => {
  const colorMap: Record<OpportunityStatusString, string> = {
    "0": "#9e9e9e", // Grå
    "1": "#64b5f6", // Ljusblå
    "2": "#4fc3f7", // Blå
    "3": "#ffd54f", // Gul
    "4": "#81c784", // Grön
    "5": "#e57373", // Röd
  };

  return colorMap[statusString] || "#9e9e9e";
};
